module.exports = __webpack_public_path__ + "img/services-2.1192a86d.jpg";